import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import common from '../common/common';
import PubSubManager from '../common/PubSubManager';
import Sorting from '../components/Sorting.jsx';
import GoogleTagManager from '../components/GoogleTagManager.jsx';
import SocialLinks from '../components/SocialLinks.jsx';
import RecentlyViewedProducts from '../components/modules/products/RecentlyViewedProducts.jsx';
import ServiceLinksDesktop from '../components/ServiceLinksDesktop.jsx';
import UserIcon from '../components/UserIcon.jsx';
import QuickCart from '../components/QuickCart.jsx';
import BannerRedirect from '../components/BannerRedirect.jsx';
import ReviewStars from '../components/modules/reviews/ReviewStars.jsx';
import LoadingComponent from '../components/LoadingComponent.jsx';

export default async () => {
  window.PubSubManager = PubSubManager;
  var element;

  element = document.getElementsByClassName('search-input-container-new');
  if (element !== null) {
    if (element.length > 0) {
      const JSportAutocomplete = React.lazy(() =>
        import('../components/autocomplete/JSportAutocomplete.jsx'),
      );
      for (let index = 0; index < element.length; index++) {
        var el = element[index];
        ReactDOM.render(
          <Suspense fallback={''}>
            <JSportAutocomplete {...el.dataset} />
          </Suspense>,
          el,
        );
      }
    }
  }

  if (!common.isDesktop()) {
    element = document.getElementById('hamburgerMenu');
    if (element !== null) {
      const HamburgerMenu = React.lazy(() =>
        import('../components/HamburgerMenu.jsx'),
      );
      ReactDOM.render(
        <Suspense fallback={''}>
          <HamburgerMenu {...element.dataset} context={window.PubSubManager} />
        </Suspense>,
        element,
      );
    }
  }

  if (common.isDesktop()) {
    element = document.getElementById('desktopMenu');
    if (element !== null) {
      const DesktopMenu = React.lazy(() =>
        import('../components/DesktopMenu.jsx'),
      );
      ReactDOM.render(
        <Suspense
          fallback={
            <LoadingComponent
              styles={{ display: 'inline-block', width: '80px' }}
            />
          }
        >
          <DesktopMenu {...element.dataset} />
        </Suspense>,
        element,
      );
    }
  }

  element = document.getElementsByClassName('infobox');
  if (element !== null) {
    if (element.length > 0) {
      const Infobox = React.lazy(() =>
        import('../components/infobox/Infoboxes.jsx'),
      );
      for (let index = 0; index < element.length; index++) {
        var el = element[index];
        ReactDOM.render(
          <Suspense fallback={<LoadingComponent />}>
            <Infobox />
          </Suspense>,
          el,
        );
      }
    }
  }

  element = document.getElementsByClassName('sorting-new');
  if (element !== null) {
    if (element.length > 0) {
      for (let index = 0; index < element.length; index++) {
        var el = element[index];
        // ReactDOM.render(
        //     <Sorting {...el.dataset} key={new Date().toISOString()} />,
        //     el
        // );
      }
    }
  }

  element = document.getElementById('google-tag-manager');
  if (element !== null) {
    ReactDOM.render(<GoogleTagManager {...element.dataset} />, element);
  }

  element = document.getElementById('social_links');
  if (element !== null) {
    ReactDOM.render(<SocialLinks />, element);
  }

  element = document.getElementsByClassName('recently-viewed-products');
  if (element !== null) {
    if (element.length > 0) {
      for (let index = 0; index < element.length; index++) {
        var el = element[index];
        ReactDOM.render(<RecentlyViewedProducts />, el);
      }
    }
  }

  element = document.getElementById('service-links-container');
  if (element !== null) {
    ReactDOM.render(<ServiceLinksDesktop {...element.dataset} />, element);
  }

  element = document.getElementById('user-icon');
  if (element !== null) {
    ReactDOM.render(<UserIcon />, element);
  }

  element = document.getElementById('quick-cart-container');
  if (element !== null) {
    ReactDOM.render(<QuickCart />, element);
  }

  element = document.getElementById('banner-redirect-container');
  if (element !== null) {
    ReactDOM.render(<BannerRedirect />, element);
  }

  // Feedback rating total in Layout
  element = document.getElementById('feedBack-ratings-total');
  if (element !== null) {
    ReactDOM.render(
      <ReviewStars maxRating={5} average={Number(element.dataset.rating)} />,
      element,
    );
  }

  // Single feedback rating in Layout
  let ratings = document.querySelectorAll('.rating.feedbacksRating');
  if (ratings !== null) {
    for (let i = 0; i < ratings.length; i++) {
      ReactDOM.render(
        <ReviewStars
          maxRating={5}
          average={Number(ratings[i].dataset.rating)}
        />,
        ratings[i],
      );
    }
  }
};
